<template>
  <div>
    <form @submit.prevent="submit()">

      <div class="mb-3">
        <SGPFormInputComponent 
            type="text" 
            :name="'rota'"
            v-model="formulario.rota" 
            :placeholder="'Nome da rota'"
            data-vv-as="Nome da rota"
            v-validate="'required'"
            :error="validationErrors.first('rota')"
         />
      </div>

      <div class="mb-3">
        <SGPFormInputComponent 
            type="text" 
            :name="'descricao'"
            v-model="formulario.descricao" 
            :placeholder="'Descrição da rota'"
            data-vv-as="Descrição da rota"
            v-validate="'required'"
            :error="validationErrors.first('descricao')"
         />
      </div>

      <div v-if="tipoFormulario === 'salvar'" class="mb-3">
          <SGPFormSelectComponent 
            :name="'usuario'"
            :listaDeOptions="listaDeUsuarios"
            v-model="formulario.usuario"
            :optionLabel="'name'"
            :placeholder="'Usuário'"
            :error="validationErrors.first('usuario')"
            data-vv-as="Usuário"
            v-validate="'required'"
          />
      </div>

      <div class="mb-3">
          <SGPFormSelectComponent 
            :name="'submodulo'"
            :listaDeOptions="listaDeSubmodulos"
            v-model="formulario.acl_submodulo_id"
            :optionLabel="'submodulo'"
            :placeholder="'Submódulo'"
            :error="validationErrors.first('submodulo')"
            data-vv-as="Submódulo"
            v-validate="'required'"
          />
      </div>

      <div class="container-botoes">
        <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize" type="submit">
          {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
        </button>
        <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
                type="button" @click="fecharModal()">Cancelar</button>
     </div>

    </form>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: "FormularioRotaComponent",

  props: {
    tipoFormulario: {
      type: String,
      required: false,
      default: 'salvar'
    },
    rota: {
      type: Object,
      require: false
    },
    descricao: {
      type: Object,
      require: false
    }
  },

  data () {
    return {
      formulario: {...this.$props.rota} || {
        rota: '',
        descricao: '',
        usuario: '',
        acl_submodulo_id: ''
      }
    }
  },

  computed: {
    ...mapGetters('rotas', ['listaDeSubmodulos']),
    ...mapGetters('usuarios', [
      'listaDeUsuarios'
    ])
  },

  methods: {
    ...mapActions('rotas', [
      'listarSubmodulos',
      'salvarRota',
      'atualizarRota'
    ]),

    ...mapActions('usuarios', [
      'listarUsuarios'
    ]),

    validate: function () {
          this.$validator.validateAll();
        },

    submit () {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          console.log('formulario', this.formulario)
          if (this.tipoFormulario === 'salvar') {
            this.fecharModal();
            await this.salvarRota(this.formulario);
          } else {
            this.fecharModal();
            await this.atualizarRota(this.formulario);
          }
        }
      });
    },

    fecharModal () {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  },

  beforeMount () {
    this.listarUsuarios();
    this.listarSubmodulos();
  }
}
</script>
